// src/supabaseClient.js
// FONTE ÚNICA do cliente Supabase do app. Nenhum componente pode chamar
// createClient() nem escrever URL/key de Supabase literal — importe daqui.
//
// Contexto (migração 17/08/2026): o app apontava para o projeto
// `qwfbqcyzehavjtcavlru`, que pertencia à org da Lovable. As tabelas que o app
// lê (gym_partner_profiles, gym_dashboard_view, exercise_library) e as edge
// functions que ele chama (track-event, mint-referral-token, validate-qr-token)
// vivem no projeto PRÓPRIO `rewjcyuknsejbdvpytdv` — por isso o track-event
// falhava com CORS/ERR_FAILED: a função não existe no projeto antigo.
//
// Havia DOIS módulos de cliente (`src/supabaseClient.js` e
// `src/supabase/client.jsx`) com configurações diferentes de auth. Este é o
// canônico; o outro virou re-export para não quebrar quem já importava de lá.

import { createClient } from "@supabase/supabase-js";

export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_PUBLISHABLE_KEY =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

/** Base das edge functions. Derivada da URL — não duplique em .env. */
export const SUPABASE_FUNCTIONS_BASE = SUPABASE_URL
  ? `${SUPABASE_URL.replace(/\/+$/, "")}/functions/v1`
  : undefined;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  // Ruidoso no boot: sem env o cliente sobe quebrado e as falhas aparecem
  // longe da causa (CORS/401 em telas aleatórias).
  console.error(
    "[supabase] REACT_APP_SUPABASE_URL e/ou REACT_APP_SUPABASE_PUBLISHABLE_KEY " +
      "ausentes — as chamadas ao Supabase vão falhar. Confira o .env.",
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});

export default supabase;
